import { PropType, computed, defineComponent, onUnmounted, reactive, ref, watch } from 'vue'
import { Store } from 'pinia'
import { ChargeMapContext } from '../../chargerMap/index.model'
import {
  ComponentActions,
  ComponentState,
  useComponentStore,
} from '../../../nsh5/localStores/component'
import { useRoute, useRouter } from 'vue-router'
import { regionCodesApi } from '../countyLayout.api'
import { DetailItem } from '../countyLayout.model'
import { cur } from '@/utils/env'
import {
  DEFAULT_CITY_ZOOM_LEVEL,
  DEFAULT_COUNTRY_ZOOM_LEVEL,
} from '@/pages/chargermap/config/zoomLevelConfig'
import debounce from 'lodash.debounce'
import { MapViewMode } from '@/pages/chargermap/contract/map'
import { useAppStore } from '@/pages/chargermap/stores/app'
/**
 * 地图上边界功能模块
 */
export default defineComponent({
  name: 'county-layout-boundary-render-view',
  props: {
    mapContextRef: {
      type: Object as PropType<ChargeMapContext>,
    },
    mapInstance: {
      type: Object,
    },
    BMapGL: {
      type: Object,
    },
    componentStore: {
      // 用于同一项目功能模块间的通信
      type: Object as PropType<Store<string, ComponentState, {}, ComponentActions>>,
      default: null,
    },
  },

  setup: (props) => {
    const BMapGL = computed(() => props.BMapGL)
    const route = useRoute()

    const state = reactive({
      city: [] as string[],
      district: [] as string[],
      province: [] as string[],
      provinceOpacity: [] as number[],
    })

    // const tileUrl = `https://gis-mvt${cur}.nio${cur ? 'int' : ''}.com/mvt/adcode/[z]/[x]/[y].pbf`

    // const componentStore = useComponentStore()

    const getStyleObj = () => {
      // 设置显示的图层
      let visibilityMatch = ['match', ['get', 'adcode'], false] as any
      if (state.city.length || state.district.length) {
        // 县和市的边界需要显示
        const codes = state.city.concat(state.district)
        const transformedCodes = codes.flatMap((code) => [code, true])
        // 计算 visibilityMatch 数组的倒数第二位置
        const insertPosition = visibilityMatch.length - 1
        // 使用 splice 插入到倒数第二位
        visibilityMatch.splice(insertPosition, 0, ...transformedCodes)
      } else {
        visibilityMatch = false
      }

      // 设置填充的图层
      let fillOpacityMatch = ['match', ['get', 'adcode'], 0] as any
      if (state.district.length) {
        // 县需要填充
        const codes = state.district
        const transformedCodes = codes.flatMap((code) => [
          code,
          (process.config as any).style.stroke_opacity,
        ])
        // 计算 fillOpacityMatch 数组的倒数第二位置
        const insertPosition = fillOpacityMatch.length - 1
        // 使用 splice 插入到倒数第二位
        fillOpacityMatch.splice(insertPosition, 0, ...transformedCodes)
      } else {
        fillOpacityMatch = 0
      }

      // // 设置边线类型
      // let strokeStyleMatch = ['match', ['get', 'adcode'], 'solid'] as any
      // if (state.city.length) {
      //   // 市的边界需要显示虚线
      //   const codes = state.city
      //   const transformedCodes = codes.flatMap((code) => [code, 'dotted'])
      //   // 县的边界需要显示实线
      //   const codes2 = state.district
      //   const transformedCodes2 = codes2.flatMap((code2) => [code2, 'solid'])
      //   // 计算 strokeStyleMatch 数组的倒数第二位置
      //   const insertPosition = strokeStyleMatch.length - 1
      //   // 使用 splice 插入到倒数第二位
      //   strokeStyleMatch.splice(insertPosition, 0, ...transformedCodes, ...transformedCodes2)
      // } else {
      //   strokeStyleMatch = 'solid'
      // }

      const style = {
        fill: {
          type: 'polygon',
          visible: true,
          painter: {
            fillColor: (process.config as any).style.fill_color,
            fillOpacity: fillOpacityMatch,
            strokeWeight: 2,
            strokeOpacity: 1,
            strokeStyle: 'solid',
            strokeColor: (process.config as any).style.stroke_color,
            visibility: visibilityMatch,
          },
        },
      }
      // console.log('====================================')
      // console.log('getStyleObj', style)
      // console.log('====================================')

      return style
    }

    // 设置省的图层
    // const getStyleObjProvince = () => {
    //   // 设置填充的图层
    //   let fillOpacityMatch = ['match', ['get', 'adcode'], 0] as any
    //   if (state.province.length) {
    //     // 县需要填充
    //     const codes = state.province
    //     const transformedCodes = codes.flatMap((code, index) => [
    //       code,
    //       state.provinceOpacity[index],
    //     ])
    //     // 计算 fillOpacityMatch 数组的倒数第二位置
    //     const insertPosition = fillOpacityMatch.length - 1
    //     // 使用 splice 插入到倒数第二位
    //     fillOpacityMatch.splice(insertPosition, 0, ...transformedCodes)
    //   } else {
    //     fillOpacityMatch = 0
    //   }

    //   const styleProvince = {
    //     fill: {
    //       type: 'polygon',
    //       visible: true,
    //       painter: {
    //         fillColor: '#00BEBE',
    //         fillOpacity: fillOpacityMatch,
    //         strokeWeight: 2,
    //         strokeOpacity: 0,
    //         strokeColor: '#00BEBE',
    //       },
    //     },
    //   }
    //   console.log('====================================')
    //   console.log('getStyleObjProvince', styleProvince)
    //   console.log('====================================')

    //   return styleProvince
    // }

    // mvt图层
    const renderMvtLayer = () => {
      if (props.componentStore.countyLayoutMvt) {
        const newStyle = getStyleObj()
        props.componentStore.countyLayoutMvt.setStyle(newStyle)
      } else {
        // const tileUrl = 'https://gis-mvt-dev.nioint.com/mvt/adcode/[z]/[x]/[y].pbf'
        // const tileUrl = 'https://gis-mvt.nio.com/mvt/adcode/[z]/[x]/[y].pbf'
        const tileUrl = 'https://gis-mvt.nio.com/mvt/adcode20260203/[z]/[x]/[y].pbf' // 重庆两江新区数据调整
        // 定义MVT layer图层
        const layer = new BMapGL.value!.MVTLayer({
          transform: {
            source: 'GCJ02',
          },
          gridModel: BMapGL.value!.MVTLayer.GridModel.GOOGLEWEB,
          encrypt: false,
          idProperty: 'fid',
          spanLevel: -1,
          noCollision: false, // 图层文字碰撞
          style: getStyleObj(),
          minZoom: DEFAULT_COUNTRY_ZOOM_LEVEL,
          maxZoom: 23,
          tileUrlTemplate: tileUrl,
          cacheSize: 256,
        })
        props.mapInstance?.addTileLayer(layer)
        props.componentStore.$patch({ countyLayoutMvt: layer })
      }
    }

    // const renderMvtLayerProvince = () => {
    //   if (props.componentStore.countyLayoutMvtProvince) {
    //     const newStyleProvince = getStyleObjProvince()
    //     props.componentStore.countyLayoutMvtProvince.setStyle(newStyleProvince)
    //   } else {
    //     const tileUrl = 'https://gis-mvt.nio.com/mvt/province/[z]/[x]/[y].pbf'
    //     // 定义MVT layer图层
    //     const layerProvince = new BMapGL.value!.MVTLayer({
    //       transform: {
    //         source: 'GCJ02',
    //       },
    //       gridModel: BMapGL.value!.MVTLayer.GridModel.GOOGLEWEB,
    //       encrypt: false,
    //       idProperty: 'fid',
    //       spanLevel: -1,
    //       noCollision: false, // 图层文字碰撞
    //       style: getStyleObjProvince(),
    //       minZoom: 3,
    //       maxZoom: DEFAULT_COUNTRY_ZOOM_LEVEL,
    //       tileUrlTemplate: tileUrl,
    //       cacheSize: 256,
    //     })
    //     props.mapInstance?.addTileLayer(layerProvince)
    //     console.log('====================================')
    //     console.log('countyLayoutMvtProvince', layerProvince)
    //     console.log('====================================')
    //     props.componentStore.$patch({ countyLayoutMvtProvince: layerProvince })
    //   }
    // }

    const getRegions = async () => {
      if (
        props.componentStore.city &&
        props.componentStore.city.code &&
        props.componentStore.city.code !== '000000'
      ) {
        const stationCode =
          props.componentStore.countyLayoutConfig.countyLayoutConfigList[
            props.componentStore.countyLayoutConfig.currentIndex
          ].itemCode
        const regionCode = props.componentStore.city.code
        const zoomLevel = props.mapInstance?.getZoom()
        // console.log('===============getRegions=====================')
        // console.log(zoomLevel)
        // console.log('====================================')
        const showMode =
          zoomLevel <= DEFAULT_COUNTRY_ZOOM_LEVEL // 全国
            ? 'nation'
            : zoomLevel <= DEFAULT_CITY_ZOOM_LEVEL // 省
            ? 'province'
            : 'city' // 市
        const res = await regionCodesApi(stationCode, regionCode, showMode)
        // console.log('==================regionCodesApi==================')
        // console.log(res, res.isValid())
        // console.log('====================================')
        if (res.data && res.data.regions.length) {
          if (showMode === 'nation') {
            // state.province = []
            // state.provinceOpacity = []
            // res.data.regions.forEach((element: DetailItem) => {
            //   state.province.push(element.regionCode)
            //   state.provinceOpacity.push(
            //     element.coverage < 30
            //       ? 0.05
            //       : element.coverage < 50
            //       ? 0.15
            //       : element.coverage < 70
            //       ? 0.25
            //       : element.coverage <= 99.9
            //       ? 0.4
            //       : 0.5
            //   )
            // })
            // renderMvtLayerProvince()
          } else {
            state.city = []
            state.district = []
            res.data.regions.forEach((item: DetailItem) => {
              if (item.regionCodeType === 'district') {
                // 区县覆盖
                state.district.push(item.regionCode)
              } else if (item.regionCodeType === 'city') {
                // 省市虚线
                state.city.push(item.regionCode)
              }
            })
            renderMvtLayer()
          }
        }
      }
    }

    const fetchRegions = debounce(getRegions, 1000)

    const destroyCountyLayout = () => {
      const appStore = useAppStore()
      props.mapContextRef?.setMinZoom(appStore.minZoomLevel) // 设置地图允许的最小级别
      if (props.componentStore.countyLayoutMvt) {
        props.componentStore.countyLayoutMvt.setStyle({
          fill: {
            type: 'polygon',
            visible: false,
          },
        })
      }
      // if (props.componentStore.countyLayoutMvtProvince) {
      //   props.componentStore.countyLayoutMvtProvince.setStyle({
      //     fill: {
      //       type: 'polygon',
      //       visible: false,
      //     },
      //   })
      // }
    }
    props.componentStore.bus.on('destroyCountyLayout', destroyCountyLayout)

    /**
     * 组件获取地图实例后的回调
     */
    const onReady = async () => {
      // if (!props.componentStore.countyLayoutMvt) {
      //   renderMvtLayer()
      // }
      if (!route.query.region_code || route.query.region_code === '000000') {
        // 防止发生多多次请求
        fetchRegions.cancel()
        fetchRegions()
      }
    }

    watch(
      () => props.mapContextRef,
      () => {
        if (props.mapContextRef) {
          onReady()
        }
      },
      {
        immediate: true,
      }
    )
    watch(
      () => [props.componentStore.city?.code, props.componentStore.countyLayoutConfig.currentIndex],
      () => {
        console.log('===================watch===change==============')
        console.log('props.componentStore.city', props.componentStore.city)
        console.log('props.mapInstance?.getZoom()', props.mapInstance?.getZoom())
        console.log('====================================')
        if (props.componentStore.city && props.componentStore.city?.code !== '000000') {
          props.mapContextRef?.setMinZoom(DEFAULT_COUNTRY_ZOOM_LEVEL + 0.01) // 设置地图允许的最小级别
          fetchRegions.cancel()
          fetchRegions()
        }
      }
    )

    onUnmounted(() => {
      props.componentStore.bus.off('destroyCountyLayout')
    })

    return () => {}
  },
})
